export default "__VITE_ASSET__Cxh5Y4yI__"